<template>
  <div class="color-band" :style="[{backgroundColor: !color || color === '' ? '#754cf5' : color}]"></div>
</template>

<script>
export default {
  name: "ColorBand",
  props: {
    color: {
      type: String
    }
  }
}
</script>